/***************************************************************
                          JavaScript
***************************************************************/
import { appLogin } from "./app_login";
import { appHeader } from "./app_header";
import { appCoupon } from "./app_coupon";
import { appRegForm } from "./app_reg_form";
import { appVHSForm } from "./app_vhs_form";
import { appHomeHero } from "./app_home_hero";
import { appTeamSlider } from "./app_team_slider";
import { appCourseTeaser } from "./app_course_teasers";
import { appCourseFilters } from "./app_course_filters";
import { appSearchOverlay } from "./app_search_overlay";
import { appProjectTeaser } from "./app_project_teasers";
import { appLightboxImage } from "./app_lightbox_image";
import { appAdd2CartWidget } from "./app_add2cart-widget";
import { appShopcartQuantity } from "./app_shopcart_quantity";
import { appSearchResSorting } from "./app_search_results_sorting";
import { appDesktopMobileToggle } from "./app_d_m_toggle";
import { appCourseSearchSorting } from "./app_course_search_sorting";
import { appHomeMapBox } from "./app_home-map-box";
import { appWidgetMap } from "./app_widget-map";
import { appStandortWidget } from "./app_standort-widget";
import { appOrdersAccordion } from "./app_orders-accordion";
import { appMail } from "./app_mail";
import { handleStylesOnSubmit } from "./utils/handleStylesOnSubmit";
import {appValidation} from "./app_validation";
import { goBack } from "./utils/goBack";

$(function () {
    // Script Initialization
    appLogin.create(); // [ app_login.js ] - Login Form functions and listeners
    appHeader.create(); // [ app_header.js ] - Header functions and listeners
    appCoupon.create(); // [ app_coupon.js ] - Coupon functions and listeners
    appRegForm.create(); // [ app_reg_form.js ] - Registeration Form functions and listeners
    appVHSForm.create(); // [ app_vhs_form.js ] - Generic Form functions and listeners
    appHomeHero.create(); // [ app_header.js ] - Header functions and listeners
    appTeamSlider.create(); // [ app_team_slider.js ] - Team Slider functions and listeners
    appCourseTeaser.create(); // [ app_course_teasers.js ] - Course Teaser functions and listeners
    appCourseFilters(); // [ app_course_filters.js ] - Course Filters functions and listeners
    appSearchOverlay.create(); // [ app_search_overlay.js ] - Search Overlay functions and listeners
    appProjectTeaser.create(); // [ app_project_teasers.js ] - Project Teaser functions and listeners
    appLightboxImage.create(); // [ app_lightbox_image.js ] - Lightbox Image functions and listeners
    appAdd2CartWidget.create(); // [ app_add2cart-widget.js ] - Add2Cart Widget functions and listeners
    appShopcartQuantity.create(); // [ app_shopcart_quantity.js ] - Shop Cart Quantity functions and listeners
    appSearchResSorting(); // [ app_search_results_sorting.js ] - Search Results Sorting functions and listeners
    appDesktopMobileToggle.create(); // [ app_d_m_toggle.js ] - Toggle aria hidden attribute depnding on breakpoint
    appCourseSearchSorting.create(); // [ app_course_search_sorting.js ] - Course Search Sorting functions and listeners
    appHomeMapBox.create(); // [ app_home-map-box.js ] - Map Block functions and listeners
    appWidgetMap.create(); // [ app_widget-map.js ] - Map Widget Block functions and listeners
    appStandortWidget.create(); // [ app_standort-widget.js ] - Standort Widget Dropdown functions and listeners
    appOrdersAccordion.create(); // [ app_orders-accordion.js ] - Orders Accordion functions and listeners
    appValidation.create(); // [ app_orders-accordion.js ] - Orders Accordion functions and listeners
    appMail.create(); // Replace encrypted Mail Links
    handleStylesOnSubmit();
});

window.goBack = goBack;